<template>

  <div class="columns my-2 is-gapless is-vcentered notification px-6 py-2" :style="{'background-color': backgroundColor}">

    <div class="column is-narrow">
        <b-icon :icon="stageIcon" class="has-text-grey" size="is-medium" > </b-icon>
    </div>
    <div class="column"> <div class="has-text-weight-bold is-size-6 has-text-centered" :class="statusColor"> {{ stageName }} reservation {{ statusMessage }} </div></div>

    <div class="column is-narrow">
      <b-icon :icon="statusIcon" :class="statusColor" class="px-2" size="is-medium"> </b-icon>
    </div>
    
  </div>

</template>

<script>
export default {
  name: "StageStatus",
  components: {},
  props: {
    stage: Object,
  },
  data: function() {
    return {};
  },
  computed: {
    backgroundColor() {
        return this.stage.isComplete ? '#def5e3' : '#ffede9';
        
    },
    statusIcon() {
        return this.stage.isComplete ? 'check-circle' : 'alert-circle';
    },
    statusColor() {
        return this.stage.isComplete ? 'has-text-success' : 'has-text-danger';
    },
    statusMessage() {
        return this.stage.isComplete ? 'success.' : 'failed.';
    },
    stageName(){
        let name = '';
        if(this.stage.slug === 'air'){
            name = 'Flight';
        } else if(this.stage.slug === 'car'){
            name = 'Car';
        } else if(this.stage.slug === 'hotel'){
            name = 'Hotel';
        }
        return name;

    },
    stageIcon() {
      let icon = "";
      if (this.stage.slug === "air") {
        icon = "airplane-takeoff";
      } else if (this.stage.slug === "car") {
        icon = "car";
      } else if (this.stage.slug === "hotel") {
        icon = "bed";
      }
        return icon;
    },
  },
};
</script>

<style></style>
